import moment from "moment";
import { useCallback, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { Spinner } from "reactstrap";

export const ButtonPrintSuratKuasaBPHTB = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 1500);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title || "Surat Kuasa BPHTB",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-item"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

export const PrintDocSuratKuasaBPHTB = ({ innerRef, item, preview = false }) => {
  const applicant = item?.sls_appl || {};

  const getPlaceDate = () => {
    const place = applicant.birth_place || "";
    const date = applicant.birthat ? moment(applicant.birthat).format("DD-MM-YYYY") : "";
    if (place && date) return `${place}, ${date}`;
    if (place) return place;
    if (date) return date;
    return "";
  };

  if (item === undefined || item === null) {
    return <></>;
  }

  return (
    <div
      className={preview ? "" : "d-none"}
      style={{
        overflow: preview ? "auto" : "scroll",
      }}
    >
      <div
        ref={innerRef}
        className="bg-white"
        style={{
          width: preview ? "100%" : "210mm",
          minHeight: preview ? "auto" : "297mm",
          padding: preview ? "40px 60px" : "2.5cm 2cm 2cm 2.5cm",
          margin: "0 auto",
          boxSizing: "border-box",
          fontFamily: '"Times New Roman", Times, serif',
          fontSize: "12pt",
          lineHeight: 1.6,
          color: "#000",
        }}
      >
        <div
          style={{
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "14pt",
            textDecoration: "underline",
            marginBottom: "25px",
            letterSpacing: "0.5px",
          }}
        >
          SURAT KUASA
        </div>

        <p style={{ marginTop: 0, marginBottom: "12px", textAlign: "justify" }}>
          Saya yang bertanda tangan di bawah ini, disebut sebagai Pihak Pertama (Pemberi Kuasa):
        </p>

        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginBottom: "15px",
            marginLeft: "10px",
          }}
        >
          <tbody>
            <tr>
              <td style={{ width: "180px", padding: "3px 0", verticalAlign: "top" }}>Nama</td>
              <td style={{ width: "20px", textAlign: "center", padding: "3px 0", verticalAlign: "top" }}>:</td>
              <td style={{ width: "auto", padding: "3px 0", verticalAlign: "top" }}>{applicant.name || ""}</td>
            </tr>
            <tr>
              <td style={{ width: "180px", padding: "3px 0", verticalAlign: "top" }}>Tempat / Tgl Lahir</td>
              <td style={{ width: "20px", textAlign: "center", padding: "3px 0", verticalAlign: "top" }}>:</td>
              <td style={{ width: "auto", padding: "3px 0", verticalAlign: "top" }}>{getPlaceDate()}</td>
            </tr>
            <tr>
              <td style={{ width: "180px", padding: "3px 0", verticalAlign: "top" }}>Pekerjaan</td>
              <td style={{ width: "20px", textAlign: "center", padding: "3px 0", verticalAlign: "top" }}>:</td>
              <td style={{ width: "auto", padding: "3px 0", verticalAlign: "top" }}>{applicant.job_desc || ""}</td>
            </tr>
            <tr>
              <td style={{ width: "180px", padding: "3px 0", verticalAlign: "top" }}>No. KTP / NIK</td>
              <td style={{ width: "20px", textAlign: "center", padding: "3px 0", verticalAlign: "top" }}>:</td>
              <td style={{ width: "auto", padding: "3px 0", verticalAlign: "top" }}>{applicant.identity || ""}</td>
            </tr>
            <tr>
              <td style={{ width: "180px", padding: "3px 0", verticalAlign: "top" }}>Alamat</td>
              <td style={{ width: "20px", textAlign: "center", padding: "3px 0", verticalAlign: "top" }}>:</td>
              <td style={{ width: "auto", padding: "3px 0", verticalAlign: "top" }}>{applicant.address || ""}</td>
            </tr>
          </tbody>
        </table>

        <p style={{ marginTop: 0, marginBottom: "12px", textAlign: "justify" }}>
          Dengan ini memberikan kuasa penuh kepada Pihak Kedua (Penerima Kuasa):
        </p>

        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginBottom: "15px",
            marginLeft: "10px",
          }}
        >
          <tbody>
            <tr>
              <td style={{ width: "180px", padding: "3px 0", verticalAlign: "top" }}>Nama Pengembang</td>
              <td style={{ width: "20px", textAlign: "center", padding: "3px 0", verticalAlign: "top" }}>:</td>
              <td style={{ width: "auto", padding: "3px 0", verticalAlign: "top" }}>
                <strong>PT. HIKMAH ALAM SENTOSA</strong>
              </td>
            </tr>
            <tr>
              <td style={{ width: "180px", padding: "3px 0", verticalAlign: "top" }}>Alamat Pengembang</td>
              <td style={{ width: "20px", textAlign: "center", padding: "3px 0", verticalAlign: "top" }}>:</td>
              <td style={{ width: "auto", padding: "3px 0", verticalAlign: "top" }}>
                PESONA KAHURIPAN 1 BLOK L 1-4 CIKAHURIPAN KLAPANUNGGAL - BOGOR
              </td>
            </tr>
            <tr>
              <td style={{ width: "180px", padding: "3px 0", verticalAlign: "top" }}>Nama Perwakilan</td>
              <td style={{ width: "20px", textAlign: "center", padding: "3px 0", verticalAlign: "top" }}>:</td>
              <td style={{ width: "auto", padding: "3px 0", verticalAlign: "top" }}>
                <strong>ANGGA BUDI KUSUMA</strong>
              </td>
            </tr>
            <tr>
              <td style={{ width: "180px", padding: "3px 0", verticalAlign: "top" }}>Jabatan</td>
              <td style={{ width: "20px", textAlign: "center", padding: "3px 0", verticalAlign: "top" }}>:</td>
              <td style={{ width: "auto", padding: "3px 0", verticalAlign: "top" }}>Direktur Utama</td>
            </tr>
          </tbody>
        </table>

        <p style={{ marginTop: 0, marginBottom: "12px", textAlign: "justify" }}>
          Untuk dan atas nama Pemberi Kuasa melakukan pengurusan Bea Perolehan Hak atas Tanah dan Bangunan (BPHTB) / Permohonan Pembebasan (Free) atau Reduksi BPHTB atas obyek tanah dan/atau bangunan milik Pemberi Kuasa.
        </p>

        <p style={{ marginTop: 0, marginBottom: "12px", textAlign: "justify" }}>
          Surat kuasa ini diberikan dengan hak substitusi. Demikian dibuat untuk dipergunakan sebagaimana mestinya.
        </p>

        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginTop: "60px",
            pageBreakInside: "avoid",
          }}
        >
          <tbody>
            <tr>
              <td style={{ width: "50%", verticalAlign: "top", textAlign: "center", padding: "0 10px" }}>
                <strong>PIHAK PERTAMA</strong>
                <br />
                (Pemberi Kuasa)
              </td>
              <td style={{ width: "50%", verticalAlign: "top", textAlign: "center", padding: "0 10px" }}>
                <strong>PIHAK KEDUA</strong>
                <br />
                (Penerima Kuasa)
              </td>
            </tr>
            <tr>
              <td style={{ height: "90px" }}></td>
              <td style={{ height: "90px" }}></td>
            </tr>
            <tr>
              <td style={{ width: "50%", verticalAlign: "top", textAlign: "center", padding: "0 10px" }}>
                ( ____________________________ )
              </td>
              <td style={{ width: "50%", verticalAlign: "top", textAlign: "center", padding: "0 10px" }}>
                ( ____________________________ )
                <br />
                <span style={{ fontWeight: "bold" }}>ANGGA BUDI KUSUMA</span>
                <br />
                PT. HIKMAH ALAM SENTOSA
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
